/* unplugin-vue-components disabled */import __unplugin_components_8 from '~icons/ep/circle-check-filled';
import __unplugin_components_7 from '~icons/ep/circle-check';
import { ElTooltip as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/tooltip/style/css';
import { ElIcon as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_4 from '~icons/ep/edit-pen';
import { ElForm as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElButton as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import __unplugin_components_0 from '/Users/zpw/Documents/hero/ultrasdk.hub.web/packages/base/src/components/GameChannelSelect/index.vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-709f3651"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索");
const _hoisted_2 = {
  key: 0,
  class: "icons-box"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 请先检查参数配置是否正确 ");
const _hoisted_5 = {
  key: 0,
  class: "icons-box"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 请先检查参数配置是否正确 ");
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 当前渠道无需在本平台配置登录方式 ");
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" - ");
const _hoisted_10 = /*#__PURE__*/_createTextVNode("-");
const _hoisted_11 = /*#__PURE__*/_createTextVNode("-");
const _hoisted_12 = /*#__PURE__*/_createTextVNode("-");
import { apuUsdkGetChannelOnlineConfig } from '@/api/usdk';
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import UseConfig from '../configHook';
import { useAppStore } from '@/store/modules/app';
export default /*#__PURE__*/_defineComponent({
  setup(__props) {
    const InternalLogin = defineAsyncComponent(() => import('./internalLogin.vue'));
    const GlobalLogin = defineAsyncComponent(() => import('./globalLogin.vue'));
    const GlobalConf = defineAsyncComponent(() => import('./globalConf.vue'));
    const gameInfo = computed(() => useAppStore().gameInfo);
    const {
      loginType
    } = UseConfig();
    const activeChannel = ref({});
    const activeCard = ref('loginList');
    const loginPanes = computed(() => {
      return [{
        title: '登录管理列表',
        key: 'loginList'
      }, {
        title: `登录开关参数配置(${activeChannel.value.name})`,
        key: 'internalLogin'
      }, {
        title: `登录开关参数配置(${activeChannel.value.name})`,
        key: 'globalLogin'
      }];
    });
    const columns = [{
      label: '渠道ID',
      prop: 'cid'
    }, {
      label: '渠道名称',
      prop: 'name'
    }, {
      label: '登录管理',
      prop: 'login',
      slot: 'login'
    },
    // 隐藏登录界面显示 20230529 @博川
    // { label: '登录界面显示', prop: 'loginPage', slot: 'loginPage' },
    {
      label: '游客登录绑定提醒',
      prop: 'tourist',
      slot: 'tourist'
    }, {
      label: '游客支付绑定提醒',
      prop: 'payBind',
      slot: 'payBind'
    }];
    const filter = reactive({
      cid: undefined,
      name: ''
    });
    const getTableData = () => {
      tableLoading.value = true;
      apuUsdkGetChannelOnlineConfig({
        gid: gameInfo.value.Id,
        ...filter
      }).then(res => {
        if (res.code === 0) {
          // this.list = res.data;
          const dict = ['internalLogin', 'globalLogin'];
          tableData.value = res.data.map(item => {
            dict.forEach(key => {
              item[key] = item[key] || {};
            });
            return item;
          });
          // res.data.forEach((item:Channel) => {
          // 	if (activeChannel.value!.id && item.id === activeChannel.value!.id) {
          // 		activeChannel.value = item;
          // 	}
          // });
        }
      }).finally(() => {
        tableLoading.value = false;
      });
    };
    const {
      tableData,
      tableLoading
    } = UseTable(getTableData);
    const activeTable = computed(() => {
      if (!filter.cid) {
        return tableData.value;
      }
      return tableData.value.filter(item => item.cid === filter.cid);
    });
    const showBind = item => {
      let val = Number(item.val);
      if (val === -1) {
        return '不弹';
      } else if (val === 0) {
        return '每次都弹';
      } else if (val) {
        return `间隔${item.memo}次弹`;
      } else {
        return '-';
      }
    };
    const showPayBind = val => {
      val = Number(val);
      if (val === 0) {
        return '不提醒';
      } else if (val === 1) {
        return '每次提醒';
      } else {
        return '-';
      }
    };
    watch(() => gameInfo.value.Id, val => {
      if (val) {
        getTableData();
        activeCard.value = 'loginList';
      }
    }, {
      immediate: true
    });
    const handleClick = (type, row) => {
      activeChannel.value = row;
      if (type === 'set') {
        var _row$internalLogin, _row$globalLogin;
        if ((_row$internalLogin = row.internalLogin) !== null && _row$internalLogin !== void 0 && _row$internalLogin.cid) {
          activeCard.value = 'internalLogin';
        } else if ((_row$globalLogin = row.globalLogin) !== null && _row$globalLogin !== void 0 && _row$globalLogin.usdk_cid) {
          activeCard.value = 'globalLogin';
        }
      }
    };
    const globalConf = ref();
    const handleClickConf = (type, row) => {
      var _globalConf$value;
      activeChannel.value = row;
      let params = row.globalLogin[type];
      (_globalConf$value = globalConf.value) === null || _globalConf$value === void 0 ? void 0 : _globalConf$value.show(type, params);
    };
    return (_ctx, _cache) => {
      const _component_game_channel_select = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_button = __unplugin_components_2;
      const _component_el_form = __unplugin_components_3;
      const _component_i_ep_edit_pen = __unplugin_components_4;
      const _component_el_icon = __unplugin_components_5;
      const _component_el_tooltip = __unplugin_components_6;
      const _component_i_ep_circle_check = __unplugin_components_7;
      const _component_i_ep_circle_check_filled = __unplugin_components_8;
      const _component_u_card_pane = _resolveComponent("u-card-pane");
      const _component_u_card = _resolveComponent("u-card");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_u_card, {
        modelValue: activeCard.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => activeCard.value = $event),
        panes: _unref(loginPanes)
      }, {
        default: _withCtx(() => [_createVNode(_component_u_card_pane, {
          name: "loginList"
        }, {
          default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_form, {
            inline: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "选择渠道"
            }, {
              default: _withCtx(() => [_createVNode(_component_game_channel_select, {
                modelValue: _unref(filter).cid,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(filter).cid = $event),
                clearable: "",
                gid: _unref(gameInfo).Id
              }, null, 8, ["modelValue", "gid"])]),
              _: 1
            }), _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                type: "primary",
                onClick: getTableData
              }, {
                default: _withCtx(() => [_hoisted_1]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }), _createVNode(UTable, {
            options: columns,
            "row-key": "cid",
            pagination: "",
            data: _unref(activeTable),
            loading: _unref(tableLoading)
          }, {
            login: _withCtx(({
              scope
            }) => {
              var _scope$row$internalLo, _scope$row$globalLogi;
              return [_ctx.$channel.INTERNAL.includes(scope.row.channel) ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 0
              }, [scope.row.internalLogin.cid ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 0
              }, [_unref(loginType)(scope.row.internalLogin).length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(loginType)(scope.row.internalLogin), (img, i) => {
                return _openBlock(), _createElementBlock("img", {
                  key: i,
                  src: img,
                  alt: ""
                }, null, 8, _hoisted_3);
              }), 128))])) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 1
              }, {
                content: _withCtx(() => [_hoisted_4]),
                default: _withCtx(() => [_createVNode(_component_el_icon, {
                  size: 16,
                  class: "edit"
                }, {
                  default: _withCtx(() => [_createVNode(_component_i_ep_edit_pen)]),
                  _: 1
                })]),
                _: 1
              }))], 64)) : _ctx.$channel.GLOBAL.includes(scope.row.channel) ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 1
              }, [scope.row.globalLogin.usdk_cid ? (_openBlock(), _createElementBlock(_Fragment, {
                key: 0
              }, [_unref(loginType)(scope.row.globalLogin, 'global').length ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(loginType)(scope.row.globalLogin, 'global'), (img, i) => {
                return _openBlock(), _createElementBlock("img", {
                  key: i,
                  src: img,
                  alt: ""
                }, null, 8, _hoisted_6);
              }), 128))])) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 1
              }, {
                content: _withCtx(() => [_hoisted_7]),
                default: _withCtx(() => [_createVNode(_component_el_icon, {
                  size: 16,
                  class: "edit"
                }, {
                  default: _withCtx(() => [_createVNode(_component_i_ep_edit_pen)]),
                  _: 1
                })]),
                _: 1
              }))], 64)) : (_openBlock(), _createBlock(_component_el_tooltip, {
                key: 2
              }, {
                content: _withCtx(() => [_hoisted_8]),
                default: _withCtx(() => [_hoisted_9]),
                _: 1
              })), (_scope$row$internalLo = scope.row.internalLogin) !== null && _scope$row$internalLo !== void 0 && _scope$row$internalLo.cid || (_scope$row$globalLogi = scope.row.globalLogin) !== null && _scope$row$globalLogi !== void 0 && _scope$row$globalLogi.usdk_cid ? (_openBlock(), _createBlock(_component_el_icon, {
                key: 3,
                size: 16,
                class: "edit",
                onClick: $event => handleClick('set', scope.row)
              }, {
                default: _withCtx(() => [_createVNode(_component_i_ep_edit_pen)]),
                _: 2
              }, 1032, ["onClick"])) : _createCommentVNode("", true)];
            }),
            loginPage: _withCtx(({
              scope
            }) => [_ctx.$channel.GLOBAL.includes(scope.row.channel) && scope.row.globalLogin.usdk_cid ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [scope.row.globalLogin.qkswitch.val == 0 ? (_openBlock(), _createBlock(_component_el_icon, {
              key: 0,
              size: 20
            }, {
              default: _withCtx(() => [_createVNode(_component_i_ep_circle_check)]),
              _: 1
            })) : (_openBlock(), _createBlock(_component_el_icon, {
              key: 1,
              size: 20,
              color: "#3f6df8"
            }, {
              default: _withCtx(() => [_createVNode(_component_i_ep_circle_check_filled)]),
              _: 1
            })), _createVNode(_component_el_icon, {
              onClick: $event => handleClickConf('qkswitch', scope.row),
              size: 16,
              class: "edit"
            }, {
              default: _withCtx(() => [_createVNode(_component_i_ep_edit_pen)]),
              _: 2
            }, 1032, ["onClick"])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
              key: 1
            }, [_hoisted_10], 64))]),
            tourist: _withCtx(({
              scope
            }) => [_ctx.$channel.GLOBAL.includes(scope.row.channel) && scope.row.globalLogin.usdk_cid ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createTextVNode(_toDisplayString(showBind(scope.row.globalLogin.showbind)) + " ", 1), _createVNode(_component_el_icon, {
              onClick: $event => handleClickConf('showbind', scope.row),
              size: 16,
              class: "edit"
            }, {
              default: _withCtx(() => [_createVNode(_component_i_ep_edit_pen)]),
              _: 2
            }, 1032, ["onClick"])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
              key: 1
            }, [_hoisted_11], 64))]),
            payBind: _withCtx(({
              scope
            }) => [_ctx.$channel.GLOBAL.includes(scope.row.channel) && scope.row.globalLogin.usdk_cid ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createTextVNode(_toDisplayString(showPayBind(scope.row.globalLogin.paybind.val)) + " ", 1), _createVNode(_component_el_icon, {
              onClick: $event => handleClickConf('paybind', scope.row),
              size: 16,
              class: "edit"
            }, {
              default: _withCtx(() => [_createVNode(_component_i_ep_edit_pen)]),
              _: 2
            }, 1032, ["onClick"])], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
              key: 1
            }, [_hoisted_12], 64))]),
            _: 1
          }, 8, ["data", "loading"])])]),
          _: 1
        }), _createVNode(_component_u_card_pane, {
          name: "internalLogin"
        }, {
          default: _withCtx(() => [_createVNode(_unref(InternalLogin), {
            onOk: getTableData,
            gid: _unref(gameInfo).Id,
            channel: activeChannel.value,
            loginParams: activeChannel.value.internalLogin
          }, null, 8, ["gid", "channel", "loginParams"])]),
          _: 1
        }), _createVNode(_component_u_card_pane, {
          name: "globalLogin"
        }, {
          default: _withCtx(() => [_createVNode(_unref(GlobalLogin), {
            onOk: getTableData,
            gid: _unref(gameInfo).Id,
            channel: activeChannel.value,
            loginParams: activeChannel.value.globalLogin
          }, null, 8, ["gid", "channel", "loginParams"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue", "panes"]), _createVNode(_unref(GlobalConf), {
        ref_key: "globalConf",
        ref: globalConf,
        onOk: getTableData,
        gid: _unref(gameInfo).Id,
        channel: activeChannel.value
      }, null, 8, ["gid", "channel"])], 64);
    };
  }
});